import React from 'react';
import {ReactComponent as IconoCerrarSesion} from './../img_icons/log-out.svg';
import { Button } from '@mui/material';
import {auth} from './../firebase/firebaseConfig';
import {signOut} from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

const BotonCerrarSesion = () => {
	const navigate = useNavigate();

	const cerrarSesion = async() => {
		try {
			await signOut(auth);
			navigate('/');
		} catch(error){
			console.log(error);
		}
	}

	return (
		<Button onClick={cerrarSesion}>
			<IconoCerrarSesion />
		</Button>
	);
}
 
export default BotonCerrarSesion;